import { DeviceLogUse } from './../../../models/dtos/access-controller/deviceLogUse';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SelectItem } from 'primeng/api';
import { CustomerService } from 'src/app/services/customer.service';
import Swal from 'sweetalert2';
import { AccessReportService } from 'src/app/services/access-controler/access-report.service';
import { MessageUtil } from 'src/app/utils/message.util';
import { DialogService } from 'primeng/dynamicdialog';
import { CustomReportExportComponent } from 'src/app/components/extract-custom-report/custom-report-export.component';

@Component({
  selector: 'app-report-access-controler',
  templateUrl: './report-access-controler.component.html',
  styleUrls: ['./report-access-controler.component.scss'],
})
export class ReportAccessControlerComponent implements OnInit {
  filteredCustomers: Array<SelectItem> = [];
  filter: any = {
    colectId: null,
    startDate: null,
    endDate: null,
    direction: null,
    accessGroupId: null,
  };
  readonly timezone: string = Intl.DateTimeFormat().resolvedOptions().timeZone;
  report: DeviceLogUse[] = [];
  onlylocal: Boolean = false;
  group: SelectItem[] = [
    { label: 'Todos', value: null },
    { label: 'Proprietário/Dependente', value: '11111' },
    { label: 'Visitante/Prestador', value: '11112' },
    { label: 'Marinheiro', value: '11113' },
    { label: 'Colaborador', value: '11114' },
  ];
  direction: SelectItem[] = [
    { label: 'Entrada', value: 'IN' },
    { label: 'Saída', value: 'OUT' },
    { label: 'Todos', value: null },
  ];

  constructor(
    private router: Router,
    private customerService: CustomerService,
    private accessReportService: AccessReportService,
    private messageUtil: MessageUtil,
    private dialog: DialogService,
  ) {}

  ngOnInit() {
    this.getCustomers();
    const endDate = new Date();
    this.filter.endDate = this.setEndOfDay(endDate);

    const startDate = new Date(endDate);
    startDate.setDate(startDate.getDate() - 7);
    this.filter.startDate = this.setStartOfDay(startDate);
  }

  find() {
    if (this.onlylocal) {
      this.accessReportService.findLastDeviceUse().subscribe((data) => {
        this.report = data;
      });
      return;
    }
    if (this.filter.colectId == null) {
      this.filter.colectId = null;
    }
    this.filter.startDate = this.setStartOfDay(this.filter.startDate);
    this.filter.endDate = this.setEndOfDay(this.filter.endDate);

    if (this.filter.startDate == null) {
      Swal.fire('Atenção', 'Data inicial é obrigatória', 'warning');
      return;
    }
    if (this.filter.endDate == null) {
      Swal.fire('Atenção', 'Data final é obrigatória', 'warning');
      return;
    }

    if (this.filter.startDate > this.filter.endDate) {
      Swal.fire(
        'Atenção',
        'Data inicial não pode ser maior que a data final',
        'warning'
      );
      return;
    }

    this.accessReportService.accessReport(this.filter).subscribe((data) => {
      this.report = data;
    });
  }

  clear() {}

  getCustomers(): void {
    this.customerService.getCustomerFilterList().subscribe((data) => {
      this.filteredCustomers = [{ label: 'Todos', value: null }].concat(
        data.map((c) => ({ label: c.name, value: c.colectId }))
      );
    });
  }

  private setStartOfDay(date: Date | string | null): Date | null {
    if (!date) {
      return null;
    }
    const normalized = new Date(date);
    normalized.setHours(0, 0, 0, 0);
    return normalized;
  }

  private setEndOfDay(date: Date | string | null): Date | null {
    if (!date) {
      return null;
    }
    const normalized = new Date(date);
    normalized.setHours(23, 59, 59, 0);
    return normalized;
  }

  exportTable(): void {
    const data = { table: this.report, type: 'REPORT_ACCESS_CONTROLER' };
    this.dialog.open(CustomReportExportComponent, {
      width: '70%',
      height: '90vh',
      dismissableMask: false,
      data,
      header: this.messageUtil.translateKey('EXPORT-TAX-PRODUCT-TABLE'),
    });
  }

  /**
   * Converte uma string ISO sem timezone para Date, assumindo que vem em UTC
   * e convertendo para o fuso horário local
   */
  convertToLocalDate(dateString: string | Date): Date | null {
    if (!dateString) return null;
    
    // Se já for um Date, retorna como está
    if (dateString instanceof Date) {
      return dateString;
    }
    
    // Se for string, verifica se tem timezone
    if (typeof dateString === 'string') {
      // Se não tem timezone (nem Z, nem +, nem - após a hora), trata como UTC
      const hasTimezone = dateString.includes('Z') || 
                         dateString.includes('+') || 
                         (dateString.match(/-/g) || []).length > 2;
      
      if (!hasTimezone) {
        // Adiciona 'Z' para indicar UTC e o JavaScript fará a conversão automática para local
        const utcDate = new Date(dateString + 'Z');
        if (!isNaN(utcDate.getTime())) {
          return utcDate;
        }
      }
    }
    
    // Se já tem timezone ou é outro formato, tenta converter normalmente
    const date = new Date(dateString);
    return isNaN(date.getTime()) ? null : date;
  }
}
